import React from "react";
import { useApiClient } from "../../../shared/customHooks";
import { kinderProgramForm } from "../../../shared/formObjects/application/kinderProgramForm";
import { useApplicationContext } from "../context/applicationContext";
import BaseApplicationComponent from "../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function KinderProgramComponent({ disabled, data }: any) {
  const api = useApiClient("KinderProgram");
  const { id } = useApplicationContext();

  return (
    <BaseApplicationComponent
      formBody={kinderProgramForm}
      headerLabel="Kindergarten Program"
      editPath="kindergartenProgram"
      apiClient={api}
      disabled={disabled}
      data={data}
      id={id}
    />
  );
}

export default KinderProgramComponent;
